module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title27"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429915410_tp01",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_copyrightNotice",
    attrs: {
      "href": "#/e9781429915410_notice",
      "id": "Notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Notice")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PRELUDE:")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("BONE IN CALIFORNIA")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c02",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER ONE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c03",
      "id": "toctitle3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER TWO")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c04",
      "id": "toctitle4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER THREE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c05",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER FOUR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c06",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER FIVE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c07",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER SIX")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c08",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER SEVEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c09",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTERLUDE:")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("BONE FINDS WORK")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c10",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER EIGHT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c11",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER NINE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c12",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER TEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c13",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER ELEVEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c14",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER TWELVE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c15",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER THIRTEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c16",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTERLUDE:")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("BONE LOSES FAITH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c17",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER FOURTEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c18",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER FIFTEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c19",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER SIXTEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c20",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER SEVENTEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c21",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER EIGHTEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c22",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER NINETEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429915410_c23",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CODA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429915410_als01",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BY ROBERT CHARLES WILSON FROM TOM DOHERTY ASSOCIATES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429915410_cop01",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-379ef198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429915410_toc01.vue
// module id = 63
// module chunks = 0